import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import IconBar from "../Partials/IconBar";
import TabPages from "../Partials/TabPages";
import ReferenceList from "../Tests/ReferenceList";
import ReactGA from "react-ga4";

export default function TestRefDashboard(props) {
  const history = useHistory();

  const activateTests = function () {
    setTabPage("tests");
    ReactGA.event({
      category: "Button Click",
      action: "Clicked Tests Tab",
    });
  };
  const activateReferences = function () {
    setTabPage("references");
    ReactGA.event({
      category: "Button Click",
      action: "Clicked References Tab",
    });
  };

  if (
    props === undefined ||
    props.location === undefined ||
    props.location.state === undefined ||
    props.location.state.user === undefined
  )
    history.push("/login");

  const user = props.location.state.user;

  if (user === undefined) history.push("/login");

  const tabHeadings = ["TESTS", "RESOURCES"];
  const tabFunctions = [activateTests, activateReferences];
  const [tabPage, setTabPage] = useState("tests");
  const tabActive = tabPage === "tests" ? 0 : 1;
  const content = tabPage === "tests" ? getTest() : getReference();
  if (localStorage.getItem("Grade") === "Grade") {
    localStorage.setItem("Grade", user.student.grade);
    localStorage.setItem("RefGrade", user.student.grade);
  }
  function getTest() {}
  function getReference() {}

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: windowWidth >= 800 ? "50%" : "90%",
      }}
    >
      <div>
        {/*tab container*/}
        <div
          style={{ position: "sticky", top: "0", backgroundColor: "#00112e" }}
        >
          {/*icon bar*/}
          <div>
            <IconBar location={"dashboard"} user={user} />
          </div>
          {/*tab headings*/}
          <div style={{ width: "100%" }}>
            <TabPages
              tabHeadings={tabHeadings}
              tabFunctions={tabFunctions}
              tabActive={tabActive}
            ></TabPages>
          </div>
        </div>
        <div style={{ backgroundColor: "#DFDFDF" }}></div>
        <div></div>
      </div>
    </div>
  );
}
